import React from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { getLedgerDetails } from "../../../redux/ledger";
import RootState from "../../../redux/type";
import {
  RazorBadgeTwo,
  RazorDateTime,
  RazorNumberFormat,
} from "../../../components/razor-reuse";
import { formatToLocalTime } from "../../../utils/Helper";

export default function LedgerDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cust_id = localStorage?.getItem("cors_key") || "";

  React.useEffect(() => {
    if (cust_id) {
      // fetch details of the transaction using cust_id
      dispatch(getLedgerDetails(cust_id) as any);
    } else {
      navigate(ALL_ROUTES?.DASHBOARD_TRANSACTION);
    }
  }, [cust_id, dispatch, navigate]);

  const { loading, ledger_record_id } = useSelector(
    (state: RootState) => state?.ledger,
  );

  console.log(ledger_record_id, "kedger");
  const ledgerDetails = {
    basic_information: {
      reference: ledger_record_id?.data?.reference || "---",
      direction: ledger_record_id?.data?.direction || "---",
      account_type: ledger_record_id?.data?.account_type || "---",
      wallet_id: ledger_record_id?.data?.wallet_id || "---",
      user_id: ledger_record_id?.data?.user_id
        ? `${ledger_record_id?.data?.user_id?.first_name} ${ledger_record_id?.data?.user_id?.last_name}`
        : "---",
      status: (
        <RazorBadgeTwo
          className={
            ledger_record_id?.data?.status === "failed"
              ? "failed"
              : ledger_record_id?.data?.status === "successful"
                ? "success"
                : ledger_record_id?.data?.status === "completed"
                  ? "success"
                  : ledger_record_id?.data?.status === "pending"
                    ? "pending"
                    : ledger_record_id?.data?.status === "processing"
                      ? "pending"
                      : ledger_record_id?.data?.status === "submitted"
                        ? "pending"
                        : ""
          }
          text={ledger_record_id?.data?.status}
        />
      ),
      description: ledger_record_id?.data?.description || "---",
    },

    financial_details: {
      amount:
        RazorNumberFormat(ledger_record_id?.data?.amount, {
          symbol: ledger_record_id?.data?.currency,
        }) || "---",
      currency: ledger_record_id?.data?.currency || "---",
      fees:
        RazorNumberFormat(ledger_record_id?.data?.fees, {
          symbol: ledger_record_id?.data?.currency,
        }) || "---",
      balance_before:
        RazorNumberFormat(ledger_record_id?.data?.balance_before, {
          symbol: ledger_record_id?.data?.currency,
        }) || "---",
      balance_after:
        RazorNumberFormat(ledger_record_id?.data?.balance_after, {
          symbol: ledger_record_id?.data?.currency,
        }) || "---",
      provider_balance_before:
        RazorNumberFormat(ledger_record_id?.data?.provider_balance_before, {
          symbol: ledger_record_id?.data?.currency,
        }) || "---",
      provider_balance_after:
        RazorNumberFormat(ledger_record_id?.data?.provider_balance_after, {
          symbol: ledger_record_id?.data?.currency,
        }) || "---",
    },

    provider_information: {
      provider: ledger_record_id?.data?.provider || "---",
      provider_reference: ledger_record_id?.data?.provider_reference || "---",
      ledger_intent: ledger_record_id?.data?.ledger_intent || "---",
    },

    timeline: {
      created_at: ledger_record_id?.data?.created_at ? (
        <RazorDateTime date={ledger_record_id?.data?.created_at} />
      ) : (
        "--- ---"
      ),
      updated_at: ledger_record_id?.data?.updated_at ? (
        <RazorDateTime date={ledger_record_id?.data?.updated_at} />
      ) : (
        "--- ---"
      ),
    },
  };

  return (
    <DashboardLayoutMain loading={loading} title="Ledger Details" back>
      <main className="grid lg:grid-cols-2 gap-[12px] gap-x-[24px] p-[18px]">
        {Object.entries(ledgerDetails).map(([sectionKey, sectionValue]) => (
          <div
            key={sectionKey}
            className="bg-white border-[0.5px] border[#3C477F1A] w-full"
          >
            {/* Section Title */}
            <h2 className="text-[#1e1e1e] font-semibold text-[16px] px-[13px] py-[17px] border-[0.5px] border-[#e6e6e6] capitalize">
              {sectionKey.replace(/_/g, " ")}
            </h2>

            {/* Section Content */}
            <div className="space-y-[16px] px-[24px] py-[17px]">
              {Object.entries(sectionValue).map(([key, value]) => (
                <div
                  key={key}
                  className="flex items-center justify-between gap-[12px]"
                >
                  <span className="text-[#758089] text-[12px] capitalize text-nowrap">
                    {key.replace(/_/g, " ")} :
                  </span>

                  <span className="text-[14px] text-[#596080] text-right">
                    {value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </main>
    </DashboardLayoutMain>
  );
}
